<template>
  <div class="sb-card__options">
    <SbMenu>
      <SbMenuButton
        icon="more-horizontal"
        has-icon-only
        label="Open card menu"
        appearance="clear"
        variant="default"
      />
      <SbMenuList :items="options" placement="bottom-end" />
    </SbMenu>
  </div>
</template>
<script lang="ts" setup>
import { SbMenu, SbMenuButton, SbMenuList, type MenuItem } from '../Menu'

export type SbCardOptionsProps = {
  options: MenuItem[]
}

defineProps<SbCardOptionsProps>()
</script>
